(ns frontend.view.modals.components.success-layer
  (:require [common.localization :as loc]))

(defn view [data-state success-text]
  [:div
   {:class "flex flex-col justify-center items-center gap-4"}
   [:img
    {:src "/img/sent-success.png"
     :class "max-w-48"}] 
   [:span 
    {:class "font-bold text-xl"}
    (or success-text (loc/tr :success))]])
